var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('ul', {
    staticClass: "list-none text-sm font-light list-inside text-left text-gray-600 flex flex-col space-y-2"
  }, _vm._l(_vm.details, function (detail, index) {
    return _c('SubscriptionDetail', {
      key: index,
      attrs: {
        "content": detail
      }
    });
  }), 1);

}
var staticRenderFns = []

export { render, staticRenderFns }